import React from 'react';
import './style.scss';
import CardsServices from 'src/views/SoftwareEngineering/components/CardsServices';
import { cardDataMlDl } from 'src/shared/utils/string';
import FooterServices from 'src/views/SoftwareEngineering/components/FooterServices';
import Footer from 'src/components/footer';
import BreadcrumbAiMl from '../Breadcrumb';
import { Link } from 'react-router-dom';

const MlDl = () => {
  return (
    <div className="page-container-mldl">
        <div className='image-container'>
          <div className='text-container drop-in-2'>
          <h1 className='heading drop-in'>Machine Learning & Deep Learning</h1>
          </div>
            <Link to="/machine-learning" className='no-decoration '><BreadcrumbAiMl text={'Machine Learning & Deep Learning'} /></Link>
            <div className='red-bg-box'></div>
        </div>

        <CardsServices cardDataServices={cardDataMlDl} />
        <FooterServices />
        <Footer />
    </div>
  )
}

export default MlDl